import { createSelector } from 'reselect';
import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getApigeeDomainSelector = createConfigSelector('apigeeDomain');

export const getIZDomainsSelector = createConfigSelector('IzHotelDomain');

export const getHotelDeepLinksUrl = ({
  hotelId,
  tripStartDate,
  tripEndDate,
  hotelRoomType,
  noOfRooms = '1',
  noOfAdults = '2',
}) => (state) => `${getIZDomainsSelector(state)}/hotel_detail?hotel_id=${hotelId}&start_date=${tripStartDate}&end_date=${tripEndDate}&num_rooms=${noOfRooms}&number_adults=${noOfAdults}&partner_program=${hotelRoomType}`;

export const getContextApiUrlSelector = createSelector(
  getApigeeDomainSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context/inquiry_results`
);

export const clearContextApiUrlSelector = createSelector(
  getApigeeDomainSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context`
);

export const postContextFeedbackApiUrlSelector = createSelector(
  getApigeeDomainSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context/feedback`
);
